export default __webpack_public_path__ + "static/media/DB_5.7385cca4.png";